import { render, staticRenderFns } from "./_Imgs.vue?vue&type=template&id=7153fe59&"
import script from "./_Imgs.vue?vue&type=script&lang=js&"
export * from "./_Imgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports